<template>
  <div class="app-container">
    <!-- 用户搜索部分 -->
    <div class="search-container" style="display: flex;">
      <div>
        <el-input v-model="searchForm.account"  placeholder="搜索账号" class="search-input" @input="handleSearch"></el-input>
      </div>
      <div style="padding-left: 10px">
        <el-input v-model="searchForm.level"  placeholder="按级别搜索" class="search-input" @input="handleSearch"></el-input>
      </div>
      <div style="padding-left: 10px">
        <el-input v-model="searchForm.id"  placeholder="按照id搜索" class="search-input" @input="handleSearch"></el-input>
      </div>
      <div style="padding-left: 10px">
        <el-input v-model="searchForm.agent"  placeholder="按照代理id搜索" class="search-input" @input="handleSearch"></el-input>
      </div>
      <div>
        <el-button type="primary" @click="fetchUsers">搜索</el-button>
      </div>
      <div>
        <el-checkbox v-model="resetPassword">重置密码</el-checkbox>
      </div>
    </div>

    <!-- 用户表格展示 -->
    <el-table :data="users" style="width: 100%">
      <el-table-column property="id" label="用户ID" width="120"></el-table-column>
      <el-table-column property="account" label="账号"></el-table-column>
      <el-table-column property="bigPoints" label="大图点数"></el-table-column>
      <el-table-column property="points" label="点数"></el-table-column>
      <el-table-column property="nai5PermanentPoints" label="NAI5永久点数"></el-table-column>
      <el-table-column property="nai5DailyPoints" label="NAI5每日剩余"></el-table-column>
      <el-table-column property="nai5DailyQuota" label="NAI5每日额度"></el-table-column>
      <el-table-column label="NAI5最近刷新日" width="150">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.nai5DailyResetDate) }}
        </template>
      </el-table-column>
      <el-table-column property="level" label="级别"></el-table-column>
      <el-table-column property="agent" label="代理id"></el-table-column>
      <el-table-column label="操作" width="180">
        <template v-slot:default="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column label="过期时间">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.expireTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalUsers"></el-pagination>

    <!-- 编辑用户信息的对话框 -->
    <el-dialog title="编辑用户信息" :visible.sync="dialogVisible" width="30%">
      <el-form :model="currentRow">
        <el-form-item label="账号">
          <el-input v-model="currentRow.account" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="resetPassword">
          <el-input v-model="currentRow.password" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="点数">
          <el-input v-model="currentRow.points" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="大图点数">
          <el-input v-model="currentRow.bigPoints" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="NAI5永久点数">
          <el-input v-model="currentRow.nai5PermanentPoints" type="number" min="0" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="级别">
          <el-input v-model="currentRow.level" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker
              v-model="currentRow.expireTime"
              type="datetime"
              placeholder="选择过期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取消</el-button>
    <el-button type="primary" @click="handleUpdate">更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { createUserEditSnapshot, buildUserEditPatch } from '../utils/userEditPatch.mjs';

export default {
  data() {
    return {
      resetPassword:false,
      searchForm: {
        account: ''
      },
      users: [],
      totalUsers: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      currentRow: {},
      originalRow: {}
    };
  },
  methods: {
    formatDate(timestamp) {
      if (timestamp == null || timestamp === '') return '—';
      let formattedDate = new Date(timestamp); // 将时间戳从秒转换为毫秒
      let year = formattedDate.getFullYear();
      let month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // 注意月份是从0开始的，因此要加1
      let day = String(formattedDate.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    },
    async fetchUsers() {
      try {
        const response = await axios.post('/api/admin/userPage', {
          account: this.searchForm.account,
          level: this.searchForm.level, // 添加 level 字段
          current: this.currentPage,
          size: this.pageSize,
          id:this.searchForm.id,
          agent:this.searchForm.agent,
        },{
          headers: {
            'token': this.$cookies.get('token'),
          }
        });
        this.users = response.data.data;
        this.totalUsers = response.data.total;
      } catch (error) {
        this.$message.error('Error fetching users: ' + error.message);
      }
    },

    handleEdit(user) {
      this.originalRow = createUserEditSnapshot(user);
      this.currentRow = { ...this.originalRow };
      this.dialogVisible = true;
    },
    async handleUpdate() {
      try {
        const changes = buildUserEditPatch(this.originalRow, this.currentRow, this.resetPassword);
        if (Object.keys(changes).length === 1) {
          this.$message.info('没有需要更新的内容');
          return;
        }
        const response = await axios.put('/api/admin/updateUser', changes,{
          headers: {
            'token': this.$cookies.get('token'),
          }
        });
        if (!response.data || Number(response.data.code) !== 200) {
          this.$message.error((response.data && response.data.msg) || '用户更新失败');
          return;
        }
        this.$message.success('用户更新成功');
        this.dialogVisible = false;
        this.fetchUsers();
      } catch (error) {
        this.$message.error('Error updating user: ' + error.message);
      }
    },
    handleSearch() {

      this.currentPage = 1;
      this.fetchUsers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchUsers();
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>
